/* eslint-disable no-console */
import axios from "axios"
import { Credentials } from "google-auth-library"

import { CONNECTION_FAILED } from "const"
import {
    MtDriveCloudInitClient,

    MtDriveCloudAuthUrl,
    MtDriveCloudAuthUrlResponse,

    MtDriveCloudConfirmCode,
    MtDriveCloudConfirmCodeResponse,

    MtDriveCloudConnect,
    MtDriveCloudConnectResponse,

    MtDriveCloudGetFile,
    MtDriveCloudGetFileResponse,

    MtDriveCloudUploadResponse,

    MtDriveCloudDelete,
    MtDriveCloudDeleteResponse,
} from "server/models"
import { POST } from "client/store/utils"
import { LangType } from "client/store"
import { UploadCallback } from "client/utils"
import { BalloonMessage } from "client/components"


export const GoogleCreateServerClient = (initData: MtDriveCloudInitClient) => (
    POST(
        "/google/initConnection/createClient",
        JSON.stringify(initData),
    )
)

interface GoogleGenerateAuthUrlResponse {
    validation: string
    authUrl: string
}
export const GoogleGenerateAuthUrl = (props: MtDriveCloudAuthUrl, lang: LangType) => (
    POST(
        "/google/initConnection/generateAuthUrl",
        JSON.stringify(props),
    ).then((res: MtDriveCloudAuthUrlResponse) => {
        if (res.errorMessage === CONNECTION_FAILED) {
            const response: GoogleGenerateAuthUrlResponse = {
                validation: lang.connectionFailed,
                authUrl: null,
            }
            return response
        }

        const response: GoogleGenerateAuthUrlResponse = {
            validation: null,
            authUrl: res.authUrl,
        }
        return response
    })
)

interface GoogleConfirmCodeResponse {
    validation: string
    token: Credentials
}
export const GoogleConfirmCode = (props: MtDriveCloudConfirmCode, lang: LangType) => (
    POST(
        "/google/initConnection/confirmCode",
        JSON.stringify(props),
    ).then((res: MtDriveCloudConfirmCodeResponse) => {
        if (res.errorMessage === CONNECTION_FAILED) {
            if (res.error) console.log(res.error)
            const response: GoogleConfirmCodeResponse = {
                validation: lang.connectionFailed,
                token: null,
            }
            return response
        }

        const response: GoogleConfirmCodeResponse = {
            validation: null,
            token: res.token as Credentials,
        }
        return response
    })
)

export const GoogleConnect = (props: MtDriveCloudConnect) => (
    POST(
        "/google/connect",
        JSON.stringify(props),
    ).then((res: MtDriveCloudConnectResponse) => {
        if (res.errorMessage) {
            BalloonMessage(`Google Drive: ${res.errorMessage}`)
            if (res.error) console.log(res.error)
        }
    })
)

export const GoogleGetObject = (props: MtDriveCloudGetFile) => (
    POST(
        "/google/getObject",
        JSON.stringify(props),
    ).then((res: MtDriveCloudGetFileResponse) => {
        if (res.errorMessage) {
            BalloonMessage("Error file load. Check console")
            console.log(res.errorMessage)
            return null
        }
        return res.base64
    })
)

export const GoogleUpload = (
    file: File,
    accountId: number,
    callback: UploadCallback,
) => {
    const data = new FormData()
    data.append("file", file)
    data.append("accountId", accountId.toString())

    const apiUrl = process.env.NODE_ENV === "development" ? "/api" : ""

    axios.post(`${apiUrl}/google/upload`, data)
    .then((res) => {
        const response = res.data as MtDriveCloudUploadResponse
        if (response.errorMessage) {
            BalloonMessage("Error upload. Check console")
            console.log(response.errorMessage)
            if (response.error) console.log(response.error)
            callback(null, null)
        }

        if (response.fileId) {
            callback(response.fileId, null)
        }
    })
}

export const GoogleDelete = (
    accountId: number,
    fileIds: string[],
) => {
    const data: MtDriveCloudDelete = {
        accountId,
        fileIds,
    }
    return POST(
        "/google/delete",
        JSON.stringify(data),
    ).then((res: MtDriveCloudDeleteResponse) => {
        if (res.errorMessage) {
            BalloonMessage("Error delete. Check console")
            console.log(res.errorMessage)
            return false
        }
        if (res.errorArray && res.errorArray.length > 0) {
            BalloonMessage("Error delete. Check console")
            console.log(res.errorArray)
            return false
        }
        return res
    })
}
